import { graphql } from "gql.tada";
import { ThemeFragment } from "./ThemeFragment";

export const CaseStudyBodySectionFragment = graphql(
  `
    fragment CaseStudyBodySectionFragment on CaseStudyBodySection {
      sys {
        id
      }
      title
      body {
        json
        links {
          entries {
            inline {
              sys { id }
              __typename
              ... on RichEntry {
                body { json }
              }
            }
          }
        }
      }
      theme {
        ...ThemeFragment
      }
      imageSlidesCollection(limit: 10) {
        items {
          url
          contentType
          title
        }
      }
    }
  `,
  [ThemeFragment]
);
